//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Typography } from '@mui/material';
import DateTimeDisplay from '../_common/DateTimeDisplay';
import AssigneeSelect from '../_common/AssigneeSelect/AssigneeSelect';
import { CustomerProfile } from '@/redux/slices/slice_types';
import { findandFormatUTCDateInString } from '@/_utils/date';
import ProfileOverflowMenu from '../_common/OverflowMenu/ProfileOverflowMenu';

export default {
  id: {
    label: 'ID',
    render: (cell: CustomerProfile['id']) => <Typography variant="subtitle1">{cell}</Typography>
  },
  name: {
    label: 'Profile Name',
    render: (cell: CustomerProfile['name']) => <strong>{findandFormatUTCDateInString(cell)}</strong>
  },
  customer_name: {
    label: 'Customer'
  },
  created_by: {
    label: 'Created By',
    render: (cell: CustomerProfile['created_by']) => <AssigneeSelect value={cell} assigns="user" emptyText="-" viewOnly />
  },
  created_at: {
    label: 'Created',
    render: (cell: CustomerProfile['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  updated_by: {
    label: 'Updated By',
    render: (cell: CustomerProfile['updated_by']) => <AssigneeSelect value={cell} assigns="user" emptyText="-" viewOnly />
  },
  updated_at: {
    label: 'Updated',
    render: (cell: CustomerProfile['updated_at'], row: CustomerProfile) => {
      const createdDate = row.created_at?.substring(0, row.created_at?.indexOf('.'));
      return cell === createdDate ? '-' : <DateTimeDisplay>{cell}</DateTimeDisplay>;
    }
  },
  overflow: {
    label: '',
    render: (_cell: any, row: CustomerProfile) => <ProfileOverflowMenu row={row} />
  }
};
